import axios from 'axios'
import moment from 'moment'
export default {
  logOut: async ({ commit }) => {
    commit('setUser', null)
    commit('setUsers', null)
    commit('setList', null)
  },
  authentication: async ({ commit, dispatch }, payload) => {
    try {
      const { data: result } = await axios.get('GetLogin', {
        params: {
          usuario: payload.username,
          senha: payload.password
        }
      })
      commit('setUser', result.user)
      commit('setUsers', result.users)
      commit('setList', result.list.map(elem => {
        return {
          ...elem,
          date: moment(elem.date).format('L')
        }
      }))
      // await dispatch('GetListagem', result.user)
      return true
    } catch (error) {
      commit('snackbar/show', {
        text: 'Usuario ou senha incorretos',
        color: 'error'
      }, { root: true })
      return false
    }
  },
  getListagem: async ({ commit, getters }) => {
    try {
      const { data: result } = await axios.get('GetListagem', {
        params: {
          idUsuario: getters.user.id
        }
      })
      commit('setUsers', result.users)
      moment.locale('pt-br')
      commit('setList', result.list.map(elem => {
        return {
          ...elem,
          date: moment(elem.date).format('L')
        }
      }))
    } catch (error) {
      commit('snackbar/show', {
        text: 'Erro ao carregar informações',
        color: 'error'
      }, { root: true })
    }
  }
}
